
(function() {
  const TARGET_SELECTOR = [
  '.product-form__input--pill',
  '.product-form__input--swatch',
  '.product-form__input--dropdown',
  '.js.product-form__input'
].join(', ');
  
  let cachedWidget = null;
  let isRepositioning = false;

  function getTargetElement() {
    const targets = document.querySelectorAll(TARGET_SELECTOR);
    if (!targets.length) return null;
    return targets[targets.length - 1];
  }

  function reInitAppWidget() {
    try {
      if (window.tlFreeGiftOffer?.embedWidget) {
        window.tlFreeGiftOffer.embedWidget.targetElements = window.tlFreeGiftOffer.embedWidget.getTargetElements();
        window.tlFreeGiftOffer.embedWidget.initializeEmbedWidgetElement();
      }
    } catch (e) {
      console.warn('[Salepify Embed] Re-init error:', e);
    }
  }

  function positionSalepifyWidget() {
    if (isRepositioning) return;

    try {
      const targetElement = getTargetElement();
      if (!targetElement) return;

      let placementMarker = document.querySelector('.salepify-embed-widget-placement');
      if (!placementMarker) {
        placementMarker = document.createElement('div');
        placementMarker.className = 'salepify-embed-widget-placement';
        isRepositioning = true;
        targetElement.insertAdjacentElement('afterend', placementMarker);
        isRepositioning = false;
      }

      let widgetContainer = document.querySelector('.salepify-embed-widget__embedded-list-container');
      if (widgetContainer) {
        cachedWidget = widgetContainer;
      } else if (cachedWidget) {
        widgetContainer = cachedWidget;
      } else {
        reInitAppWidget();
        return;
      }

      const desiredPrevious = placementMarker || targetElement;
      if (widgetContainer && widgetContainer.previousElementSibling !== desiredPrevious) {
        isRepositioning = true;
        desiredPrevious.insertAdjacentElement('afterend', widgetContainer);
        isRepositioning = false;
      }
    } catch (err) {
      isRepositioning = false;
      console.warn('[Salepify Embed] Repositioning error:', err);
    }
  }

  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const url = args[0] ? (typeof args[0] === 'string' ? args[0] : (args[0].url || '')) : '';
    const isSectionFetch = url.includes('section_id=') || (url.includes('variant=') && url.includes('option_values='));

    const response = await originalFetch.apply(this, args);

    if (isSectionFetch) {
      setTimeout(positionSalepifyWidget, 50);
      setTimeout(positionSalepifyWidget, 200);
      setTimeout(positionSalepifyWidget, 500);
    }

    return response;
  };

  const observer = new MutationObserver(function(mutations) {
    for (const m of mutations) {
      if (isRepositioning) return;
      for (const node of m.removedNodes) {
        if (node.nodeType === 1 && (node.classList?.contains('salepify-embed-widget__embedded-list-container') || node.querySelector?.('.salepify-embed-widget__embedded-list-container'))) {
          positionSalepifyWidget();
          return;
        }
      }
    }
  });

  function init() {
    positionSalepifyWidget();
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
